<template>
    <div class="block" v-if="$store.state.type !== 'curch'">
        <a href="#" :class="isLoad ? 'title open':'title'" @click.prevent="getItems">Количество обучающихся
            предпрофессиональных классов</a>
        <transition name="fade">
            <div class="content" v-if="isLoad">
                <!-- <p>Ведутся технические работы</p> -->
                <loading v-if="!this.items"/>
                <table v-else>
                    <thead>
                    <tr>
                        <th width="300">Проект предпрофессионального образования</th>
                        <th>Класс</th>
                        <th width="100">Количество обучающихся</th>
                        <th>ФИО классного руководителя</th>
                    </tr>
                    </thead>
                  <tbody>
                  <template v-for="prog in items" >
                  <tr v-for="item in prog.program.items">
                      <td>{{prog.program.city_project_title}}</td>
                      <td>{{item.name_classroom}}</td>
                      <td>{{item.person}}</td>
                      <td>{{item.classroom_teacher}}</td>
                  </tr>
                  </template>
                  </tbody>
                   <tfoot>
                   <tr style="font-weight: bold">
                       <td colspan="2">Всего обучающихся</td>
                       <td>{{totalPerson}}</td>
                       <td></td>
                   </tr>
                   </tfoot>
                </table>
            </div>
        </transition>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Axios from 'axios'
  import Loading from "../Loading";
  export default {
    name: "CountPupils",
    components: {
      'loading': Loading
    },
    computed: {
      ...mapState({
        localNumberStudents: 'numberStudents',
        status: 'status',
        type: 'type'
      }),
      totalPerson(){
            let sum = 0;
            this.items.forEach(function(prog) {
                prog.program.items.forEach(function(item) {
                    sum += parseInt(item.person);
                });
            });
            return sum;
        }
    },
    data() {
      return {
        items: false,
        isLoad: false,
        projects:["eng","it","med","media","acad","pedagog","predpri"]
      }
    },
    methods: {
      getItems() {
        if (!this.isLoad && !this.items) {
          this.isLoad = true
          const $this = this
          // let path = this.$store.state.api + this.$store.state.apiCountPupils + "?eoId=" + this.$store.state.eoId
          let path = this.$store.state.apiGo +this.$store.state.apiGoCountPupils + this.$store.state.eoId + "?program=" + this.getActiveType().slice(0, -1)
          Axios({
            method: "get",
            url: path,
            headers: {
              "Access-Control-Allow-Origin":"*",
              Authorization: 'Bearer ' + this.$store.state.goApiToken
            }
          }).then((res) => {
              $this.items = res.data.data
          }).catch(() => {
            $this.items = []
          })
        } else {
          this.isLoad = !this.isLoad
        }
      },
      getActiveType(){
        let data='';
        let $this = this
        this.$store.state.statuses.forEach(function(it){
            if (it.status!=='no'
                && $this.projects.indexOf(it.projectType) !==-1
            )
              data+=it.projectType+','
        })
        return data
      }

    },
  }
</script>

<style scoped>

</style>
